module.exports = __webpack_public_path__ + "img/person-circle-outline.6fea15cd.svg";